module.exports = function(data) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }

 if (data.showGradient) { ;
__p += '<div class="left-gradient off"></div><div class="right-gradient off"></div>';
 } ;
__p += '\n<h3 class="table-name header drag-grip"></h3>\n<div class="smarttable-header">\n    ';
 if (data.hasLockedColumns) { ;
__p += '\n    <div class="smarttable-header-locked locked-columns">\n        <table class="table table-bordered">\n            <colgroup></colgroup>\n            <thead></thead>\n        </table>\n    </div>';
 } ;
__p += '<div class="smarttable-header-static static-columns">\n        <table class="table table-bordered ' +
((__t = ( data.hasLockedColumns ? '' : 'table-hover' )) == null ? '' : __t) +
'">\n            <colgroup></colgroup>\n            <thead></thead>\n        </table>\n    </div>\n</div>\n';
 if (data.hasLockedColumns) { ;
__p += '\n<div class="smarttable-content-locked locked-columns">\n    <table class="table table-bordered">\n        <colgroup></colgroup>\n        <tbody></tbody>\n    </table>\n</div>';
 } ;
__p += '<div class="smarttable-content-static static-columns">\n    <table class="table table-bordered ' +
((__t = ( data.hasLockedColumns ? '' : 'table-hover' )) == null ? '' : __t) +
'">\n        <colgroup></colgroup>\n        <tbody></tbody>\n    </table>\n</div>\n<div class="table-pager"></div>\n';
 if (data.showLoadMore && data.limitRows && data.limitRows <= data.totalRows) { ;
__p += '\n<div class="load-more row">\n    <div class="col-md-3">Showing <b class="limitRows">' +
((__t = ( Math.min(data.limitRows, data.totalRows) )) == null ? '' : __t) +
'</b> out of <b class="totalRows">' +
((__t = ( data.totalRows )) == null ? '' : __t) +
'</b> rows</div>\n    <div class="col-md-offset-6 col-md-3 load-more-links"><a href="#" class="more">Load more</a> | <a href="#" class="all">Show all</a> </div>\n</div>\n';
 } ;
__p += '\n';
return __p
}